import { MAX_TESTIMONIALS_PER_CATEGORY } from '../../../constants/constants';
import { Testimonial, TestimonialCategories } from '../types/testimonial';

/**
* Sorts testimonials by category priority only, without secondary date sorting.
* Returns an empty array if no categories are provided.
*
* @param testimonials - Array of testimonial objects to sort
* @param testimonialCategories - Object mapping category names to priority numbers (lower = higher priority)
* @param limit - Maximum number of testimonials to return (default: 9)
* @returns Sorted array of testimonials, limited to the specified count
*/
const sortTestimonialsByCategory = (
    testimonials: Testimonial[],
    testimonialCategories: TestimonialCategories | null | undefined,
    limit = MAX_TESTIMONIALS_PER_CATEGORY,
): Testimonial[] => {
    if (!testimonialCategories) {
        return [];
    }

    return testimonials
        .sort((a: Testimonial, b: Testimonial) => (
            (testimonialCategories[a.category] ?? 99) - (testimonialCategories[b.category] ?? 99)
        ))
        .slice(0, limit);
};

export default sortTestimonialsByCategory;
